export default __webpack_public_path__ + "static/media/Eyes of Zug.c02af8b3.jpg";